module.exports = __webpack_public_path__ + "static/img/xingyeyingyong1.65fd4738.png";